<script>
	import { Col, Row, Image } from "sveltestrap";
	import PageHeader from "../PageHeader/PageHeader.svelte";
	import { convert } from "../../services/helpers";
	export let detailData;
	import { navigate } from "svelte-routing";
</script>

<Row class="card-detail flex-grow-1" style="min-height:0">
	<Col xs={12}>
		{#if detailData.vehicleImages}
			<PageHeader
				title={detailData.vehicleMakeName +
					" " +
					detailData.vehicleModelName +
					" " +
					detailData.plateNumber}
			/>
		{:else}
			<PageHeader title="Car Details" />
		{/if}
	</Col>

	{#if detailData.vehicleImages}
		<Col xs={12}>
			<Image
				thumbnail
				src={detailData.vehicleImages[0]}
				alt="vehicle image"
			/>
		</Col>
	{/if}
	<Col>
		{#if !detailData.vehicleImages}
			<Row class="my-3">
				<Col>Vehicle</Col>
				<Col>
					<b>
						{detailData.vehicleMakeName}
						{detailData.vehicleModelName}
						{detailData.plateNumber}
					</b>
				</Col>
			</Row>
		{/if}
		<Row class="my-3">
			<Col><span>Status</span></Col>
			<Col>
				{#if detailData.status === 1}
					<p class="status-bar-detail status-bar-1">Active</p>
				{:else if detailData.status === 0}
					<p class="status-bar-detail status-bar-3">Inactive</p>
				{/if}
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Active Start Date</span></Col>
			<Col>
				<b>{convert(detailData.activeFrom)}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Active End Date</span></Col>
			<Col>
				<b>{convert(detailData.activeTo)}</b>
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span>Enrollment Date</span></Col>
			<Col>
				<b>{convert(detailData.activeFrom)}</b>
			</Col>
		</Row>
		<Row class="card-detail-child ">
			<Col xs={12}>
				<PageHeader title="Car Location" />
			</Col>
			<Row>
				<Col xs={6}><span>Carpark ID</span></Col>
				<Col xs={6}>
					<p
						class="link"
						on:keyup={() => {}}
						on:click={() =>
							navigate(
								`/carpark-management/details/${detailData.carParkId}`
							)}
					>
						<span class="link link-text"
							><b>{detailData.carParkName}</b></span
						>
					</p>
				</Col>
			</Row>
			<Row>
				<Col xs={6}><span>Carpark Address</span></Col>
				<Col xs={6}>
					<b>{detailData.carParkAddress}</b>
				</Col>
			</Row>
			<Row>
				<Col xs={6}><span>Carpark Lot</span></Col>
				<Col xs={6}>
					{#if detailData.carParkLots.length > 0}
						{#each detailData.carParkLots as lot}
							<li style="list-style: none;">
								No: <b>{lot.lotNumber}</b>, Level:
								<b>{lot.level}</b>
							</li>
						{/each}
					{:else}
						<p>-</p>
					{/if}
				</Col>
			</Row>
		</Row>
		<Row class="card-detail-child my-3">
			<Col xs={12}>
				<PageHeader title="Fuel Card(s)" />
			</Col>
			<Row>
				<Col xs={6}><span>Fuel Card Number</span></Col>
				<Col xs={6}>
					<p>
						<span class="link link-text"
							>{#if detailData.fuelCards.length > 0}
								{#each detailData.fuelCards as fuelCard}
									<li
										style="list-style: none;"
										on:keyup={() => {}}
										on:click={() => {
											navigate(
												`/fuel-card-management/edit?id=${fuelCard.id}`
											);
										}}
									>
										<b>{fuelCard.cardNo}</b>
									</li>
								{/each}
							{:else}
								<p>-</p>
							{/if}</span
						>
					</p>
				</Col>
			</Row>
			<Row>
				<Col xs={6}><span>Company</span></Col>
				<!-- <Col xs={6}>
					{#if detailData.evChargingAccounts.length > 0}
						{#each detailData.evChargingAccounts as fuelCard}
							<li style="list-style: none;">
								<b>{detailData.evChargingAccounts.password}</b>
							</li>
						{/each}
					{:else}
						<p>-</p>
					{/if}
				</Col> -->
			</Row>
			<Row>
				<Col xs={6}><span>Pin</span></Col>
				<Col xs={6}>
					{#if detailData.fuelCards.length > 0}
						{#each detailData.fuelCards as fuelCard}
							<li style="list-style: none;">
								<b>{fuelCard.pin}</b>
							</li>
						{/each}
					{:else}
						<p>-</p>
					{/if}
				</Col>
			</Row>
		</Row>
		<!-- {#if detailData.evChargingAccounts.length > 0}
			{#each detailData.evChargingAccounts as evChargingAccounts}
				<Row class="card-detail-child my-3">
					<Col xs={12}>
						<PageHeader title="Ev Charging Account" />
					</Col>
					<Row>
						<Col xs={6}><span>Email</span></Col>
						<Col xs={6}>
							<p
								class="link"
								on:click={() => {
									navigate(
										`/ev-account-management/edit?id=${evChargingAccounts.id}`
									);
								}}
							>
								<span class="link link-text">
									{evChargingAccounts.email}
								</span>
							</p>
						</Col>
					</Row>
					<Row class="mb-2">
						<Col xs={6}><span>Password</span></Col>
						<Col xs={6}>
							{#if evChargingAccounts.password !== ""}
								<p class="text-wrap mb-0">
									{show
										? evChargingAccounts.password
										: "*".repeat(
												evChargingAccounts.password
													.length
										  )}
								</p>
								<button
									on:click={() => (show = !show)}
									class="eyeIcons"
								>
									{#if show}
										<FaRegEyeSlash />
									{:else}
										<FaRegEye />
									{/if}
								</button>
							{:else}
								<p>-</p>
							{/if}
						</Col>
					</Row>
					<Row>
						<Col xs={6}><span>Company</span></Col>
						<Col xs={6}>
							{#if evChargingAccounts.ev_company !== ""}
								<p>{evChargingAccounts.ev_company}</p>
							{:else}
								<p>-</p>
							{/if}
						</Col>
					</Row>
				</Row>
			{/each}
		{/if} -->
		<!-- <Row class="my-3">
			<Col><span>Lot level</span></Col>
			<Col>
				{#each detailData.lots as lot}
					<li style="list-style: none;"><b>{lot.level}</b></li>
				{/each}
			</Col>
		</Row>
		<Row class="my-3">
			<Col><span> Priority </span></Col>
			<Col>
				<b>{detailData.priority}</b></Col
			>
		</Row>
		<Row class="my-3">
			<Col><span> Open To </span></Col>
			<Col>
				
			</Col>
		</Row>
		<Row class="my-3">
			<Col>
				<span> Assigned to </span>
			</Col>
			<Col>
				<a href="" class="link">
					<span class="link link-text"> {detailData.assignedToName} </span>
				</a></Col
			>
		</Row>
		<Row class="my-3">
			<Col><span> Total Incentive </span></Col>
			<Col><b>${detailData.totalIncentive}</b></Col>
		</Row>
		<Row class="my-3">
			<Col><span>Status</span></Col>
			<Col>
				{#if detailData.status === 0}
					<b>Open</b>
				{:else if detailData.status === 1}
					<b>Taken</b>
				{:else if detailData.status === 2}
					<b>Complete</b>
				{:else if detailData.status === 3}
					<b>Incomplete</b>
				{:else if detailData.status === 4}
					<b>Deleted</b>
				{:else if detailData.status === 5}
					<b>Overdue</b>
				{/if}
			</Col>
		</Row>
		<!-- <Row class="pt-3 my-3" style="border-top: 1px solid gray">
			<Col
				><a href="" class="link">
					<b class="link-text"> Edit Job </b>
				</a></Col
			>
		</Row>
		<Row class="my-3">
			<Col
				><a href="" class="link">
					<b class="link-text"> Unassign Job </b>
				</a></Col
			>
		</Row> -->
	</Col>
</Row>

<style>
	/* .eyeIcons {
		border-radius: 10px;
		width: 32px;
		height: 32px;
		display: flex;
		justify-content: center;
		align-items: center;
	} */
</style>
